module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Incoterms Postal Place"},"no":{"title":"Incoterms poststed"}}')
  delete Component.options._Ctor
}
